import { useState } from "react";
import BookActivity from "components/feed/BookActivity";
import ActivityProps from "./ActivityFeedItemProps";
import StatusLink from "./parts/StatusLink";
import UserBookActivitySnapshot from "types/UserBookActivitySnapshot";

interface UserBookActivityDataType {
  userBook: UserBookActivitySnapshot;
}

export default function UserBookActivity({ activity }: ActivityProps) {
  const [user] = useState(activity.user);
  const [userBook] = useState<UserBookActivitySnapshot>(
    (activity.data as UserBookActivityDataType).userBook
  );

  return (
    <div className="py-2">
      <BookActivity activity={activity} userBook={userBook}>
        <StatusLink
          userBook={userBook}
          statusId={userBook.statusId}
          username={user.username}
        />
      </BookActivity>
    </div>
  );
}
